// extracted by mini-css-extract-plugin
module.exports = {"multiple-types":"_5jC39","multipleTypes":"_5jC39"};